import {RSAA} from 'redux-api-middleware';
import {API_ENDPOINT, AUTH_HEADERS, X_AUTHORIZATION, API_ENDPOINT_V2, X_AUTH_HEADERS} from "../util/constants";
import * as types from './types/index';
import {
    RESET_FORGOT_PASSWORD, 
    RESET_LOGIN, RESET_REGISTER, 
    RESET_USERNAME, 
    RESET_TWO_FACTOR_AUTH, 
    RESET_TWO_FACTOR_AUTH_VERIFY_OTP,
    RESET_PROMOCODE
} from "./types";
import {handleUnauthorizedAccess} from "../util/utility";

export function validateUsername(username) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT_V2}/validate/username/${username}`,
            method: 'GET',
            headers: {
                Accept:'application/vnd.vuepay.v2+json',...AUTH_HEADERS,
            },
            types: [types.VALIDATE_USERNAME_REQUEST, types.VALIDATE_USERNAME_RECEIVE, types.VALIDATE_USERNAME_FAILURE]
        }
    }
}


export function validatePromocode(promocode) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/validate/promocode/${promocode}`,
            method: 'GET',
            headers:AUTH_HEADERS,
            types: [types.VALIDATE_PROMOCODE_REQUEST, types.VALIDATE_PROMOCODE_RECEIVE, types.VALIDATE_PROMOCODE_FAILURE]
        }
    }
}

export const resetPromoCode = () => ({
    type: RESET_PROMOCODE,
    payload: null
});

export const resetUsername = () => ({
    type: RESET_USERNAME,
    payload: null
});

export function register(data) {
    //console.log(AUTH_HEADERS);
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT_V2}/register`,
            method: 'POST',
            headers: {
                Accept:'application/vnd.vuepay.v2+json',...AUTH_HEADERS,
            },
            body: JSON.stringify(data),
            types: [types.REGISTER_REQUEST, types.REGISTER_RECEIVE, types.REGISTER_FAILURE]
        }
    }
}

export function towFactorAuth(data, token, api_token) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT_V2}/viewer/resend/otp?api_token=${api_token}`,
            method: 'POST',
            headers: {
                Accept:'application/vnd.vuepay.v2+json',...X_AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: data,
            types: [types.TWO_FACTOR_AUTH_REQUEST, types.TWO_FACTOR_AUTH_RECEIVE, types.TWO_FACTOR_AUTH_FAILURE]
        }
    }
}

export const resetTwoFactorAuth = () => ({
    type: RESET_TWO_FACTOR_AUTH,
    payload: null
});

export function twoFactorAuthVerifyOtp(token, api_token,data) {
    for (var pair of data.entries()) {
        //console.log(pair[0]+ ', ' + pair[1]);

    }
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT_V2}/viewer/validate/otp?api_token=${api_token}`,
            method: 'POST',
            headers: {
                Accept:'application/vnd.vuepay.v2+json',...X_AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: data,
            types: [types.TWO_FACTOR_AUTH_VERIFY_OTP_REQUEST, types.TWO_FACTOR_AUTH_VERIFY_OTP_RECEIVE,types.TWO_FACTOR_AUTH_VERIFY_OTP_FAILURE]
        }
    }
}

export const resetTwoFactorAuthVerifyOtp = () => ({
    type: RESET_TWO_FACTOR_AUTH_VERIFY_OTP,
    payload: null
});

export const resetRegister = () => ({
    type: RESET_REGISTER,
    payload: null
});

export function login(data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/authenticate`,
            method: 'POST',
            headers: AUTH_HEADERS,
            body: JSON.stringify(data),
            types: [types.LOGIN_REQUEST, types.LOGIN_RECEIVE, types.LOGIN_FAILURE]
        }
    }
}

export const resetLogin = () => ({
    type: RESET_LOGIN,
    payload: null
});

export function forgotPassword(data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/forgot-password`,
            method: 'POST',
            headers: AUTH_HEADERS,
            body: JSON.stringify(data),
            types: [types.FORGOT_PASSWORD_REQUEST, types.FORGOT_PASSWORD_RECEIVE, types.FORGOT_PASSWORD_FAILURE]
        }
    }
}

export const resetPassword = () => ({
    type: RESET_FORGOT_PASSWORD,
    payload: null
});

export function getUserDetails(token, api_token) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/user/details?api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.USER_DETAILS_REQUEST, types.USER_DETAILS_RECEIVE, {
                type: types.USER_DETAILS_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const updateUserData = (data) => ({
    type: types.USER_DETAILS_RECEIVE,
    payload: {
        data:[data]
    }
});

export const resetUserData = (data,isReset) => ({
    type: types.RESET_USER_DETAILS,
    payload: {
        ...data,
        isReset:isReset
    }
});
export function changePassword(data,token,api_token) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/change-password?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
            types: [types.CHANGE_PASSWORD_REQUEST, types.CHANGE_PASSWORD_RECEIVE, types.CHANGE_PASSWORD_FAILURE]
        }
    }
};

export function changeEmail(data,token,api_token) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/update/email?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
            types: [types.CHANGE_PASSWORD_REQUEST, types.CHANGE_PASSWORD_RECEIVE, types.CHANGE_PASSWORD_FAILURE]
        }
    }
};

export function uploadProfilePicture(data, token, api_token) {
    //console.log(data);
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/user/upload/profile_pic?api_token=${api_token}`,
            method: 'POST',
            headers: {
                'X-Authorization': X_AUTHORIZATION,
                Authorization: `Bearer ${token}`
            },
            body: data,
            types: [types.UPLOAD_PROFILE_PICTURE_REQUEST, types.UPLOAD_PROFILE_PICTURE_RECEIVE, {
                type: types.UPLOAD_PROFILE_PICTURE_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export function yotiIntegration(token, api_token) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT_V2}/yoti/verify/broadcaster?api_token=${api_token}`,
            method: 'GET',
            headers: {
                Accept:'application/vnd.vuepay.v2+json',...X_AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.YOTI_INTEGRATION_REQUEST, types.YOTI_INTEGRATION_RECEIVE, types.YOTI_INTEGRATION_FAILURE]
        }
    }
}

export const resetYotiDetail = () => ({
    type: types.RESET_YOTI_INTEGRATION,
    payload: null
});

export const resetProfilePicture = () => ({
    type: types.RESET_UPLOAD_PROFILE_PICTURE,
    payload: null
});